import * as React from 'react';
import UnifiedEventPropertyTable from 'flow-doctor-lib/components/timeline/labels/UnifiedEventPropertyTable';
import usePropertyEventChangedPropertiesAndDefinitions from 'flow-doctor-lib/hooks/usePropertyEventChangedPropertiesAndDefinitions';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyChangeEventPropertyTable = ({
  properties,
  propertyDefinitions,
  associatedObjectTypeId
}) => {
  const {
    mappedPropertyDefinitions,
    mappedProperties
  } = usePropertyEventChangedPropertiesAndDefinitions({
    propertyDefinitions,
    properties,
    associatedObjectTypeId
  });
  return /*#__PURE__*/_jsx(UnifiedEventPropertyTable, {
    properties: mappedProperties,
    propertyDefinitions: mappedPropertyDefinitions
  });
};
export default PropertyChangeEventPropertyTable;